import type { RouteRecordRaw } from 'vue-router';
import { RouterView } from 'vue-router';

const routes: RouteRecordRaw = {
  name: 'MyThesisProposalEvaluations',
  path: 'thesis_proposal_evaluations',
  component: RouterView,
  children: [
    {
      name: 'MyThesisProposalEvaluationsList',
      path: '',
      component: () => import('pages/thesis_proposal_evaluations/ListPage.vue'),
      meta: {
        authz: ({ roles }) => roles['ROLE_THESIS_COMMITTEE'],
        breadcrumb: [
          { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
          { icon: 'assignment', label: 'Thesis proposal evaluation' },
        ],
      },
    },
    {
      name: 'MyThesisProposalEvaluationsShow',
      path: ':thesisId',
      component: () => import('pages/thesis_proposal_evaluations/ShowPage.vue'),
      meta: {
        authz: ({ roles }) => roles['ROLE_THESIS_COMMITTEE'],
        breadcrumb: [
          { icon: 'home', label: 'My Thesis', to: { name: 'MyThesis' } },
          {
            icon: 'assignment',
            label: 'Thesis proposal evaluation',
            to: { name: 'MyThesisProposalEvaluationsList' },
          },
          { icon: 'visibility', label: 'Details' },
        ],
      },
    },
  ],
};

export const thesisProposalEvaluationRoutes = routes;
